module.exports = __webpack_public_path__ + "static/media/ma_hasta200Banner.5afbffe4.png";